var $03102f9a88680039$exports = {};
const $03102f9a88680039$var$mail = document.body.querySelector('#about #mail');
const $03102f9a88680039$var$email = document.createElement('a');
const $03102f9a88680039$var$decoded = atob('bWFpbHRvOkN4UmVTQHBSb1RvTi5tRQ==');
$03102f9a88680039$var$email.textContent = $03102f9a88680039$var$decoded.substring(7);
$03102f9a88680039$var$email.href = $03102f9a88680039$var$decoded.toLowerCase().replace('@', '+website@');
$03102f9a88680039$var$email.title = "Send E-mail";
$03102f9a88680039$var$email.rel = "foaf:mbox";
$03102f9a88680039$var$mail.prepend($03102f9a88680039$var$email);


//# sourceMappingURL=email.33023ced.js.map
